// Preact imports
import "preact/devtools";
import "preact/debug";
import { h, render } from 'preact';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

//import { Socket } from "phoenix";

Sentry.init({
    dsn: "https://e9f059098d0b4c948bf541014dfffdf1@o229086.ingest.sentry.io/6294564",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});


// App component import
import BKApp from './BKApp';

// We need to import the CSS so that webpack will load it.
// The MiniCssExtractPlugin is used to separate it out into
// its own CSS file.
import "../css/app.scss"

// webpack automatically bundles all modules in your
// entry points. Those entry points can be configured
// in "webpack.config.js".
//
// Import deps with the dep name or local files with a relative path, for example:
//



//
//import "phoenix_html"

// Inject our App component into the DOM
render(<BKApp />, document.body);